import React from "react";

export function getUserInitials(name = "") {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length > 1 && ["driver", "guide", "client", "traveler"].includes(parts[parts.length - 1].toLowerCase())) {
    parts.pop();
  }
  if (parts.length > 1) return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  return parts[0]?.slice(0, 2).toUpperCase() || "U";
}

export default function ProfileAvatar({ avatarUrl, name, className = "h-9 w-9", textClassName = "text-xs" }) {
  return (
    <span className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-amber-100 font-extrabold text-amber-700 dark:bg-amber-400/15 dark:text-amber-300 ${textClassName} ${className}`}>
      {avatarUrl ? <img src={avatarUrl} alt="" loading="lazy" className="h-full w-full object-cover" /> : getUserInitials(name)}
    </span>
  );
}
